import tt2 from "refractor/tt2";
export default tt2;